import { setBodyClass } from '../helper/helpers';

export default class ModalLang {
  constructor() {
    this.btnsOpen = document.querySelectorAll('.header .btn-modal-lang');
    this.modal = document.querySelector('.header .modal-lang');

    if (!this.btnsOpen.length || !this.modal) {
      return;
    }

    this.btnActive = null;
    this.btnClose = this.modal.querySelector('.modal-lang__close');
    this.btnsLang = this.modal.querySelectorAll('.modal-lang__item');

    this.btnsOpen.forEach((btnOpen) =>
      btnOpen.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevents the modal to be immediately closed again by outside click

        this.open();
      }),
    );

    this.btnClose.addEventListener('click', this.close);
    this.btnsLang.forEach((btn) =>
      btn.addEventListener('click', () => this.selectLanguage(btn)),
    );

    window.addEventListener('click', this.handleClick);
    window.addEventListener('keyup', this.handleKeyup);
  }

  /**
   * Opens the language modal.
   */
  open = () => {
    this.modal.classList.add('is-open');
    setBodyClass('is-scroll-disabled', true);
  };

  /**
   * Closes the language modal.
   */
  close = () => {
    this.modal.classList.remove('is-open');
    setBodyClass('is-scroll-disabled', false);
  };

  /**
   * Selects a language.
   * @param {Element} btn
   */
  selectLanguage = (btn) => {
    if (this.btnActive) {
      this.btnActive.classList.remove('active');
    }

    btn.classList.add('active');
    this.btnActive = btn;
  };

  /**
   * Closes the modal if the user clicks outside of it.
   * @param {Event} e
   */
  handleClick = (e) => {
    if (!this.modal.classList.contains('is-open')) {
      return;
    }

    if (!e.target.closest('.modal-lang__wrapper')) {
      this.close();
    }
  };

  /**
   * Closes the modal if ESC is typed.
   * @param {Event} e
   */
  handleKeyup = (e) => {
    if (!this.modal.classList.contains('is-open')) {
      return;
    }

    if (e.key === 'Escape') {
      this.close();
    }
  };
}
